import { useNavigate } from "react-router-dom";
import Layout from "../assets/component/Layout";
import { Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL, BASE_URL_FILE } from "./AdmissionApplication";

export function formatDateToReadable(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export const statusColor = {
  'Approved': 'success',
  'Rejected': 'danger',
  'Pending': 'warning'
}


export default function EngineersForms() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${BASE_URL}list-form`, {
          headers: {
            Authorization: token,
          },
        });
        setForms(response.data.data?.form);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching requests:", err);
        setError("Failed to load requests");
        setLoading(false);
      }
    };

    fetchRequests();
  }, []);

  return (
    <Layout>
      <section className="Inner-page-layout">
        <div className="">
          <h1>Engineers Forms</h1>
          <div className="engineers-forms-table">
            <Container>
              <Table>
                <thead>
                  <tr>
                    <th>Submission date</th>
                    <th>Form Name</th>
                    <th>View</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {forms?.length ?
                    forms.map((res, i) =>
                      <tr key={res._id} >
                        <td>{formatDateToReadable(res.createdAt)}</td>
                        <td>{res?.document_type}</td>
                        <td>
                          <a href={`${BASE_URL_FILE}${res?.pdf}`} target="_blank">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M5 20h14v-2H5v2zm7-18L5.33 9h3.34v4h4.66v-4h3.34L12 2z"
                                fill="red"
                              />
                            </svg>
                          </a>
                        </td>
                        <td>
                          <p className={`text-${statusColor[res.status]}`} >
                            {res.status}
                          </p>
                        </td>
                      </tr>
                    )
                    : null}
                </tbody>
              </Table>
            </Container>
          </div>
        </div>
      </section>
    </Layout>
  );
}
